
<template>
    <div class="nucleicAcidTestMain">
        <van-nav-bar
            class="nucleicAcidTestNav"
            title="查看电子票"
            left-arrow
            @click-left='returnPage'
        />
        <iframe class="my-iframe" id="my-iframe" :src="url" ></iframe>
         
    </div>
</template>

<script>
import { NavBar,Toast,Empty,Dialog ,Loading   } from 'vant';
export default {
    data() {
        return {
            url:'',
        }
    },
    created() {
        this.url = this.$route.query.url?this.$route.query.url:'';
    },
    methods:{
        
        // 返回上一页
        returnPage() {
           this.$router.go(-1)
        },

    }
}
</script>

<style lang='scss' scpoed>
    .nucleicAcidTestNav {
        background: #2F2F2F !important;
       .van-nav-bar__left .van-icon {
            font-size: 18px;
            color: rgba(255,255,255,0.85);
        }
        .van-nav-bar__title {
            font-size: 18px;
             color: rgba(255,255,255,0.85);
        }
    }
  .my-iframe {
      width: 100vw;
      height: 100vh;
      border: none;
  }
   
</style>